<template>
  <el-dialog
    title="Edit Employee"
    :visible="visible"
    width="40%"
    :before-close="dismis"
  >
    <el-form :model="form">
      <div class="row">
        <div class="col-4">
          <el-image :src="form.image"></el-image>
        </div>
        <div class="col-8">
          <el-form-item label="NPP">
            <el-input
              v-model="form.npp"
              :disabled="false"
              autocomplete="off"
              @input="checkValidationNPP"
            ></el-input>
          </el-form-item>
          <small class="error-validation" v-if="is_npp_valid"
            >NPP doesn't valid</small
          >
          <el-form-item label="Name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Gender">
            <br />
            <el-radio v-model="form.gender" :label="1">Laki-laki</el-radio>
            <el-radio v-model="form.gender" :label="0">Perempuan</el-radio>
          </el-form-item>
          <el-form-item label="Email">
            <el-input
              type="email"
              v-model="form.email"
              autocomplete="off"
              @input="checkValidateEmail"
            ></el-input>
          </el-form-item>
          <small class="error-validation" v-if="is_email_valid"
            >Email doesn't valid</small
          >
          <el-form-item label="Date of Birth">
            <el-input
              type="date"
              v-model="form.dob"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="Position">
        <div style="margin: 40px 0 0"></div>
        <el-select
          v-model="form.position_id"
          placeholder="Select"
          style="width: 100%"
        >
          <el-option
            v-for="item in positions"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Jabatan">
        <el-input v-model="form.occupation" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Phone">
        <el-input v-model="form.phone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Region">
        <el-select
          :disabled="user_role_id == 2"
          style="width: 100%"
          @change="formRegionChanged"
          v-model="form.region_code"
          placeholder="Select"
        >
          <el-option
            v-for="item in regions"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Branch">
        <el-select
          style="width: 100%"
          @change="formBranchChanged"
          v-model="form.branch_code"
          placeholder="Select"
        >
          <el-option
            v-for="item in branches"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Outlet">
        <el-select
          style="width: 100%"
          v-model="form.outlet_code"
          placeholder="Select"
        >
          <el-option
            v-for="item in outlets"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dismis">Cancel</el-button>
      <el-button
        :disabled="is_npp_valid || is_email_valid"
        type="primary"
        @click="saveUser()"
        :loading="loading"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api/employees";
import regions from "@/api/regions";
import branches from "@/api/branches";
import outlets from "@/api/outlets";
export default {
  props: ["visible", "form"],
  data() {
    return {
      user_role_id: 0,
      is_npp_valid: false,
      is_email_valid: false,
      loading: false,
      currentNPP: null,
      regions: [],
      branches: [],
      outlets: [],
      positions: [
        {
          id: 1,
          text: "Pimpinan",
        },
        {
          id: 2,
          text: "Customer Service",
        },
        {
          id: 3,
          text: "Teller",
        },
        {
          id: 4,
          text: "Satpam",
        },
        {
          id: 5,
          text: "BNI Digital Assistant",
        },
      ],
    };
  },
  mounted() {
    this.user_role_id = localStorage.getItem("user_role_id");
    // console.log(this.form);
    // this.fetchRegionForEditUser();
  },
  watch: {
    form: function (newVal, oldVal) {
      // watch it
      // console.log("Prop changed: ", newVal, " | was: ", oldVal);
      this.currentNPP = newVal.npp;
      this.fetchRegionForEditUser();
    },
  },
  methods: {
    checkValidationNPP() {
      var onlyNumber = new RegExp("^[0-9]+$");

      if (onlyNumber.test(this.form.npp)) {
        this.is_npp_valid = false;
      } else {
        this.is_npp_valid = true;
      }
    },
    checkValidateEmail() {
      const re = new RegExp(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      if (re.test(this.form.email)) {
        this.is_email_valid = false;
      } else {
        this.is_email_valid = true;
      }
    },
    dismis() {
      this.$parent.dismisForm();
    },
    fetchOutletForEditUser() {
      var self = this;
      outlets
        .getAll(this.form.region_code, this.form.branch_code)
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.outlets = regionsx;
          // self.dialogForm2Visible = true
          // console.log(self.outlets)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchBranchForEditUser() {
      var self = this;
      branches
        .getAll(this.form.region_code)
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.branches = regionsx;
          self.fetchOutletForEditUser();
          // self.dialogForm2Visible = true
          // console.log(self.outlets)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchRegionForEditUser() {
      var self = this;
      regions
        .getAll()
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.regions = regionsx;
          // self.dialogForm2Visible = true
          self.fetchBranchForEditUser();
          // console.log(self.outlets)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    formRegionChanged(val) {
      // console.log('region ganti')
      // console.log(val)
      this.form.region_code = val;
      this.form.branch_code = "";
      this.form.outlet_code = "";
      this.fetchBranchForEditUser();
    },
    formBranchChanged(val) {
      // console.log('branch ganti')
      // console.log(val)
      this.form.branch_code = val;
      this.form.outlet_code = "";
      this.fetchOutletForEditUser();
    },
    saveUser() {
      var params = {
        name: this.form.name,
        npp: this.form.npp,
        gender: this.form.gender,
        email: this.form.email,
        dob: this.form.dob,
        position_id: this.form.position_id,
        outlet_code: this.form.outlet_code,
        occupation: this.form.occupation,
        phone: this.form.phone,
      };
      this.loading2 = true;
      var self = this;
      api
        .update(this.currentNPP, params)
        .then(function (response) {
          self.loading = false;
          self.$parent.dialogForm2Visible = false;
          self.$parent.fetch();
          // console.log(response);
          self.$message({
            type: "success",
            message: response.data.message,
          });
        })
        .catch(function (error) {
          self.loading = false;
          // console.log(error);
          self.$message({
            type: "error",
            message: error.response.data.message,
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-validation {
  font-size: 12px;
  color: red;
}
</style>
